import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { KeyboardBar } from '@/experiences/sales-portal/components/keyboard-bar';
import { TouchableOpacity } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface OrderEntryMobileCatalogSearchBarProps {
  isEnabled: boolean;
  isVisible: boolean;
  onPress: () => void;
}

export const OrderEntryMobileCatalogSearchBar: React.FC<
  OrderEntryMobileCatalogSearchBarProps
> = ({ isEnabled, isVisible, onPress }) => {
  const [styles, theme] = useStyles();
  const label = i18n.t('sales_portal.order_entry.search_catalog_cta');

  return (
    <KeyboardBar isVisible={isVisible}>
      <TouchableOpacity
        accessibilityLabel={label}
        accessibilityRole="button"
        accessibilityState={{ disabled: !isEnabled }}
        disabled={!isEnabled}
        onPress={onPress}
        style={[styles.pill, !isEnabled && styles.pillDisabled]}
      >
        <Typography
          color={
            isEnabled
              ? theme.sk.color.text.primary
              : theme.sk.color.text.disabled
          }
          variant="paragraph-sm-600"
        >
          {label}
        </Typography>
      </TouchableOpacity>
    </KeyboardBar>
  );
};

const useStyles = createStyles((theme) => ({
  pill: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.button.secondary.default,
    borderColor: theme.sk.color.border.button.secondary.default,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    height: 32,
    justifyContent: 'center',
    paddingHorizontal: theme.sk.spacing.spaceSMedium,
  },
  pillDisabled: {
    backgroundColor: theme.sk.color.bg.button.secondary.disabled,
    borderColor: theme.sk.color.border.button.disabled,
  },
}));
